export default __webpack_public_path__ + "static/media/man2ipad.5bc8a3db.jpg";